module.exports = __webpack_public_path__ + "static/media/bg-palm-spiral-1.aa26fef3.svg";